module.exports = __webpack_public_path__ + "static/media/procurement.dda5b76b.svg";